import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { DataService } from 'src/app/services/data.service';
import { ConvertService } from 'src/app/services/convert.service';
import { GENDERS, DISPLAY_STATUS_OBJECT, STATUS_OBJECT } from 'src/app/dummy/status';
import { ITrainingBatch } from 'src/app/interfaces/training';
import { TrainingStore } from 'src/app/stores/training/training.store';
import { MappingService, pushToArray } from 'src/app/services/mapping.service';

@Component({
  selector: 'app-add-training-batch',
  templateUrl: './add-training-batch.component.html',
  styleUrls: ['./add-training-batch.component.scss']
})
export class AddTrainingBatchComponent implements OnInit {
  @ViewChild('focusInput', {static:false}) inputEl: ElementRef;

  form: FormGroup;
  level: AbstractControl;
  tutor: AbstractControl;


  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;
  isCreate: boolean = false;
  TITLE = 'Add new batch';
  GENDER: any = GENDERS;
  ITEM: ITrainingBatch;

  LEVEL_LIST: any;
  TUTOR_LIST: any;

  constructor(
    public dialogRef: MatDialogRef<AddTrainingBatchComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private auth: AuthStore,
    public store: TrainingStore,
    private snackBar: MatSnackBar,
    private ds: DataService,
  ) { }

  async ngOnInit() {
    const { ITEM, PROGRAM_KEY } = this.data;
    this.ITEM = ITEM || null;
    this.form = this.fb.group({
      name: [ITEM ? ITEM.name : null, Validators.compose([Validators.required, ])],
      level: [ITEM ? ITEM.levelKey : null, Validators.compose([Validators.required, MappingService.validSelected.bind(this)])],
      tutor: [ITEM ? ITEM.tutorKey : GENDERS[0], Validators.compose([Validators.required,MappingService.validSelected.bind(this)])],
      description: [ITEM ? ITEM.description : null,],
    })
    this.level = this.form.controls['level'];
    this.tutor = this.form.controls['tutor'];

    const LEVEL_LIST = pushToArray(await this.ds.programRef().doc(PROGRAM_KEY).collection('levels', ref => ref.orderBy("page_key")).get().toPromise())
    const TUTOR_LIST = pushToArray(await this.ds.tutorRef(ref => ref.orderBy("fullName")).get().toPromise())

    this.LEVEL_LIST = MappingService.autoComplete(this.level, LEVEL_LIST, "name");
    this.TUTOR_LIST = MappingService.autoComplete(this.tutor, TUTOR_LIST, "fullName");

    if (ITEM) {
      this.TITLE = "Edit batch";
      const { levelKey, tutorKey } = ITEM;

      this.form.patchValue({
        level: LEVEL_LIST.filter(m => m.key === levelKey)[0],
        tutor: TUTOR_LIST.filter(m => m.key === tutorKey[0])[0]
      })
    }
  }

  compareWithObj(a: any, b: any): boolean {
    if (b) return a.key === b.key;
  }


  displayItem(item: any): string {
    return item ? item.name || item.fullName : item;
  }
  displayItemFullName(item: any): string {
    return item ? item.fullName : item;
  }

  async onSave(f: any, isDraft: boolean, isNew: boolean) {
    this.processClose = isDraft ? false : true;
    this.processNew = isDraft;
    this.error = null;
    this.isCreate = true;
    if (this.form.valid) {
      this.form.disable();
      const { description, level, tutor, name } = f;
      const { ITEM, PROGRAM_KEY } = this.data;
      const { user, selectedCompanyKey } = this.auth;
      const registerStatus = STATUS_OBJECT.submitted;
      const item: ITrainingBatch = {
        key: ITEM ? ITEM.key : this.ds.createId(),
        status: DISPLAY_STATUS_OBJECT.ACTIVE,
        isDelete: false,
        created_at: ITEM ? ITEM.created_at : new Date(),
        created_by: ITEM ? ITEM.created_by : user.uid,
        updated_at: new Date(),
        updated_by: user.uid,
        date_key: ITEM ? ITEM.date_key : ConvertService.dateKey(),
        page_key: ITEM ? ITEM.page_key : ConvertService.pageKey(),
        keyword: ConvertService.toCapitalize(`${name}`),
        organizationRef: selectedCompanyKey ? this.ds.companyRef().doc(selectedCompanyKey).ref : null,
        organizationKey: selectedCompanyKey || null,
        created_byRef: ITEM ? ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
        updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
        register_status: registerStatus,

        description, name,
        levelKey: level.key,
        levelRef: this.ds.levelRef().doc(level.key).ref,
        tutorKey: [tutor.key],
        tutorRef: [this.ds.tutorRef().doc(tutor.key).ref],
        programKey: PROGRAM_KEY,
        programRef: this.ds.programRef().doc(PROGRAM_KEY).ref,

      }
      this.store.addBatch(item, (success, res) => {
        if (success) {
          this.snackBar.open("Batch has been saved successful.", "Done", { duration: 1000 });
          if (!isNew) {
            this.dialogRef.close('no')
            return;
          }
          this.form.reset();
          this.form.enable();
          this.processNew = false;
          this.processClose = false;
          this.isCreate = false;
          this.inputEl.nativeElement.focus()
        }

      })
    }
    else {
      this.processNew = false;
      this.processClose = false;
      this.isCreate = false;
    }
  }
}